export interface StatColumn {
  title: string
  abbr: string
  defaultValue: string
  tooltip: string
}

export function getPlayerColumns(
  sportName: string | null,
  isGenericSport: boolean
): StatColumn[] {
  if (isGenericSport) {
    return [
      { title: 'GP', abbr: 'GP', defaultValue: '0', tooltip: 'Games Played' },
      { title: 'P', abbr: 'P', defaultValue: '0', tooltip: 'Total Points' },
      {
        title: 'PTS/G',
        abbr: 'PTS/G',
        defaultValue: '0.00',
        tooltip: 'Average Points Per Game',
      },
    ]
  }

  if (sportName === 'soccer') {
    return [
      { title: 'MP', abbr: 'MP', defaultValue: '0', tooltip: 'Matches Played' },
      { title: 'G', abbr: 'G', defaultValue: '0', tooltip: 'Goals' },
      { title: 'A', abbr: 'A', defaultValue: '0', tooltip: 'Assists' },
      {
        title: 'GFA',
        abbr: 'GFA',
        defaultValue: '0',
        tooltip: 'Goals For Average',
      },
      {
        title: 'FC',
        abbr: 'FC',
        defaultValue: '0',
        tooltip: 'Fouls Committed',
      },
      { title: 'YC', abbr: 'YC', defaultValue: '0', tooltip: 'Yellow Cards' },
      { title: 'RC', abbr: 'RC', defaultValue: '0', tooltip: 'Red Cards' },
      { title: 'BC', abbr: 'BC', defaultValue: '0', tooltip: 'Blue Cards' },
    ]
  }

  // Hockey / default
  return [
    { title: 'GP', abbr: 'GP', defaultValue: '0', tooltip: 'Games Played' },
    { title: 'G', abbr: 'G', defaultValue: '0', tooltip: 'Goals' },
    { title: 'A', abbr: 'A', defaultValue: '0', tooltip: 'Assists' },
    { title: 'P', abbr: 'P', defaultValue: '0', tooltip: 'Points' },
    {
      title: 'PiM',
      abbr: 'PiM',
      defaultValue: '0',
      tooltip: 'Penalty Minutes',
    },
    {
      title: 'PPG',
      abbr: 'PPG',
      defaultValue: '0',
      tooltip: 'Power Play Goals',
    },
    {
      title: 'PTS/G',
      abbr: 'PTS/G',
      defaultValue: '0.00',
      tooltip: 'Points Per Game',
    },
  ]
}

export function getGoalieColumns(sportName: string | null): StatColumn[] {
  if (sportName === 'soccer') {
    return [
      { title: 'MP', abbr: 'MP', defaultValue: '0', tooltip: 'Matches Played' },
      { title: 'GA', abbr: 'GA', defaultValue: '0', tooltip: 'Goals Against' },
      {
        title: 'GAA',
        abbr: 'GAA',
        defaultValue: '0.00',
        tooltip: 'Goals Against Average',
      },
      {
        title: 'SV%',
        abbr: 'SV%',
        defaultValue: '0.000',
        tooltip: 'Save Percentage',
      },
      { title: 'SV', abbr: 'SV', defaultValue: '0', tooltip: 'Saves' },
      { title: 'CS', abbr: 'CS', defaultValue: '0', tooltip: 'Clean Sheets' },
      { title: 'W', abbr: 'W', defaultValue: '0', tooltip: 'Wins' },
      { title: 'L', abbr: 'L', defaultValue: '0', tooltip: 'Losses' },
      { title: 'D', abbr: 'D', defaultValue: '0', tooltip: 'Draws' },
    ]
  }

  // Hockey / default
  return [
    { title: 'GP', abbr: 'GP', defaultValue: '0', tooltip: 'Games Played' },
    { title: 'W', abbr: 'W', defaultValue: '0', tooltip: 'Wins' },
    { title: 'L', abbr: 'L', defaultValue: '0', tooltip: 'Losses' },
    { title: 'T', abbr: 'T', defaultValue: '0', tooltip: 'Ties' },
    {
      title: 'OTL',
      abbr: 'OTL',
      defaultValue: '0',
      tooltip: 'Overtime Losses',
    },
    {
      title: 'GAA',
      abbr: 'GAA',
      defaultValue: '0.00',
      tooltip: 'Goals Against Average',
    },
    {
      title: 'SV%',
      abbr: 'SV%',
      defaultValue: '0.000',
      tooltip: 'Save Percentage',
    },
    { title: 'SO', abbr: 'SO', defaultValue: '0', tooltip: 'Shutouts' },
    { title: 'Min', abbr: 'MIN', defaultValue: '0', tooltip: 'Minutes Played' },
    {
      title: 'PiM',
      abbr: 'PiM',
      defaultValue: '0',
      tooltip: 'Penalty Minutes',
    },
    { title: 'SA', abbr: 'SA', defaultValue: '0', tooltip: 'Shots Against' },
    { title: 'SV', abbr: 'SV', defaultValue: '0', tooltip: 'Saves' },
    { title: 'GA', abbr: 'GA', defaultValue: '0', tooltip: 'Goals Against' },
  ]
}

export function getStatValue(
  record: any,
  abbr: string,
  defaultValue: string
): string {
  const stat = record.stats?.find(
    (s: any) => s.type?.abbr === abbr || s.abbr === abbr
  )
  return stat?.value || defaultValue
}

export function getPlayerTitle(
  sportName: string | null,
  isGenericSport: boolean
): string {
  if (isGenericSport || sportName === 'soccer') {
    return 'Player'
  }
  if (sportName === 'hockey') {
    return 'Skater'
  }
  return 'Player'
}

export function getGoalieTitle(sportName: string | null): string {
  return sportName === 'soccer' ? 'Keeper' : 'Goalie'
}
